import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import { useDispatch } from 'react-redux';

import { AppBanner, Logo, OfflineEventManager } from '@parapet/common';
import { useTypedSelector } from '@app/store/root';
import { StyledPublicComponent } from '../Public/styles';
import { CookieBanner } from './CookieBanner';
import { LoginForm } from './LoginForm';
import {
  LoginContainer,
  LoginContent,
  LoginFooter,
  LoginFooterLink,
} from './styles';

export const Login: React.FC = () => {
  const dispatch = useDispatch();
  const offline = useTypedSelector(({ user }) => user.offline);

  useEffect(() => {
    OfflineEventManager.bootstrap(window, dispatch);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {offline && (
        <AppBanner title="Offline" message="Check internet connection" />
      )}
      <LoginContainer>
        <StyledPublicComponent>
          <Helmet title="Login" />

          <LoginContent>
            <Logo style={{ opacity: 0.6, transform: 'scale(1.2)' }} />
            <LoginForm />
          </LoginContent>

          <LoginFooter>
            <LoginFooterLink>
              <Link to="/forgot-password">Forgot password?</Link>
            </LoginFooterLink>

            <LoginFooterLink>
              <a
                href="https://www.parapetstudios.com/privacypolicy.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </LoginFooterLink>
          </LoginFooter>

          <CookieBanner />
        </StyledPublicComponent>
      </LoginContainer>
    </>
  );
};
